'use client';

import { List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import { format } from 'date-fns';
import Link from 'next/link';
import { FiExternalLink } from 'react-icons/fi';
/** Items that use something (a competency, a JD), each opening in a new tab; shows "Loading…" while `items` is undefined. */
export const LinkedUsageList = ({
  items,
  text,
  href,
  emptyText = 'None'
}) => {
  if (!items || items.length === 0) {
    return <Typography variant="body2" color="text.secondary" className="block px-2 py-3">
                {items ? emptyText : 'Loading…'}
            </Typography>;
  }
  return <List dense disablePadding className="py-1!">
            {items.map(item => <ListItem key={item.id} disablePadding>
                    <ListItemButton component={Link} href={href(item)} target="_blank" rel="noopener noreferrer" prefetch={false} dense className="rounded-md!">
                        <ListItemText primary={text(item)} secondary={item.createdAt ? `Created ${format(new Date(item.createdAt), 'MMM dd, yyyy')}` : undefined} slotProps={{
          primary: {
            variant: 'body1',
            noWrap: true
          },
          secondary: {
            variant: 'body2',
            color: 'text.secondary'
          }
        }} />
                        <FiExternalLink className="ml-2 shrink-0 text-[13px] text-foreground-subtle" aria-hidden="true" />
                    </ListItemButton>
                </ListItem>)}
        </List>;
};